import React, { Component, createContext } from 'react';
import classnames from 'classnames/bind';
import { bool, string, node } from 'prop-types';

import { sizeMap } from './common';

import styles from './FormField.css';

const cx = classnames.bind(styles);

export const { Provider, Consumer } = createContext();

/*

  First (top) level of the input tree.
  This component will handle all general and common props that all children
  in this tree might need.

*/

class FormField extends Component {
  static propTypes = {
    disabled: bool,
    readonly: bool,
    size: string,
    className: string,
    darkBg: bool,
    children: node.isRequired
  }

  static defaultProps = { size: 'extra-small' }

  render() {
    const { disabled, readonly, darkBg, size, children, className } = this.props;
    const formFieldClasses = cx(
      className,
      styles.formField,
      styles[size],
      {
        isDisabled: disabled,
        readonly,
        darkBg
      },
      'form-field'
    );
    const sharedProps = {
      disabled,
      readonly,
      darkBg,
      size,
      styles,
      inputClasses: classnames(styles.input, sizeMap[size])
    };

    return (
      <Provider value={sharedProps}>
        <div className={formFieldClasses}>
          {children}
        </div>
      </Provider>
    );
  }
}

export default FormField;



// WEBPACK FOOTER //
// ./src/uis/elements/Inputs/FormField.js